import { useMemo } from "react";
import { ClientProviderEnum } from "../../../../constants/index.js";
import { PageContextUtils } from "../../../../utils/index.js";
import { useKambiMenuItemsMobile } from "./Kambi/useKambiMenuItemsMobile.js";
import { useKambiNumberOfItemsMobile } from "./Kambi/useKambiNumberOfItemsMobile.js";
import { useSpectateMenuItemsMobile } from "./Spectate/useSpectateMenuItemsMobile.js";
import { useSpectateNumberOfItemsMobile } from "./Spectate/useSpectateNumberOfItemsMobile.js";

export const useMobileCategories = () => {
  const { name } = PageContextUtils.getClientProviderData();
  const useNumberOfItems = useMemo(
    () =>
      name === ClientProviderEnum.Kambi
        ? useKambiNumberOfItemsMobile
        : name === ClientProviderEnum.Spectate
          ? useSpectateNumberOfItemsMobile
          : null,
    [name]
  );

  useNumberOfItems();

  const useMenuItems = useMemo(
    () =>
      name === ClientProviderEnum.Kambi
        ? useKambiMenuItemsMobile
        : name === ClientProviderEnum.Spectate
          ? useSpectateMenuItemsMobile
          : null,
    [name]
  );

  return useMenuItems();
};
